





























import { Vue, Component } from 'vue-property-decorator';
import HeroIllustration from '@/components/common/HeroIllustration.vue';
import ScrollWheelIndicator from '@/components/common/ScrollDownIndicator.vue';

@Component({
    components:{
        HeroIllustration,
        ScrollWheelIndicator
    }
})
export default class Hero extends Vue{

}
